(() => {
  if (window.__ynPdpTopFinalReady) return;
  window.__ynPdpTopFinalReady = true;

  const placeTopElements = (section) => {
    const header = section.querySelector('.product__section--header');
    const price = header?.querySelector('#product-price');
    if (!header || !price) return;

    const app = section.querySelector(
      '.product__section-details > .product__section--app, .product__section--header > .product__section--app'
    );
    const switcher = section.querySelector('[data-yn-model-switcher]');
    const facts = section.querySelector('.yn-signals-placement--desktop');

    let anchor = price;

    if (app) {
      price.insertAdjacentElement('afterend', app);
      app.classList.add('yn-price-history');
      anchor = app;
    }

    if (switcher) {
      anchor.insertAdjacentElement('afterend', switcher);
      switcher.dataset.ynPlaced = 'true';
      anchor = switcher;
    }

    if (facts) {
      anchor.insertAdjacentElement('afterend', facts);
    }

    section.classList.add('yn-pdp-top-final');
  };

  const initializeAssurance = (section) => {
    const root = section.querySelector('[data-yn-assurance]');
    if (!root || root.dataset.ynFinalReady === 'true') return;

    const status = root.querySelector('[data-yn-assurance-status]');
    const statusCopy = root.querySelector('[data-yn-assurance-copy]');
    const soldoutNext = root.querySelector('[data-yn-soldout-next]');
    const button = section.querySelector('[data-yn-primary-add]');
    if (!status || !statusCopy || !button) return;

    root.dataset.ynFinalReady = 'true';

    const sync = () => {
      if (status.dataset.preorder === 'true' || button.getAttribute('aria-busy') === 'true') return;
      const available = !button.disabled;
      statusCopy.textContent = available ? status.dataset.availableCopy : status.dataset.unavailableCopy;
      root.classList.toggle('yn-assurance--available', available);
      root.classList.toggle('yn-assurance--unavailable', !available);
      if (soldoutNext) soldoutNext.hidden = available;
    };

    new MutationObserver(sync).observe(button, {
      attributes: true,
      childList: true,
      attributeFilter: ['disabled', 'aria-busy']
    });
    sync();
  };

  const initializeOmnibusPricing = (section) => {
    if (section.dataset.ynOmnibusReady === 'true') return;

    const priceRoot = section.querySelector('#product-price');
    const variantInput = section.querySelector('.formVariantId');
    const productJson = section.querySelector('.product-json');
    if (!priceRoot || !variantInput || !productJson) return;

    let productData;
    try {
      productData = JSON.parse(productJson.textContent);
    } catch (error) {
      return;
    }

    const variants = Array.isArray(productData.variants) ? productData.variants : [];
    const locale = document.documentElement.lang || 'pl-PL';
    const currency = window.Shopify?.currency?.active || 'PLN';
    const savingsLabel = locale.toLowerCase().startsWith('pl') ? 'Oszczędzasz' : 'You save';

    const moneyInCents = (value) => {
      if (typeof value === 'number' && Number.isFinite(value)) return Math.round(value);
      if (value && typeof value === 'object' && value.amount != null) {
        return Math.round(Number.parseFloat(value.amount) * 100);
      }
      if (typeof value === 'string' && value.trim() !== '') {
        return Math.round(Number.parseFloat(value.replace(',', '.')) * 100);
      }
      return 0;
    };

    const formatMoney = (cents) => new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(cents / 100);

    const sync = () => {
      const variant = variants.find((item) => String(item.id) === String(variantInput.value));
      if (!variant) return;

      const price = Number(variant.price) || 0;
      const comparePrice = Number(variant.compare_at_price) || 0;
      const snapshotPrice = currency === 'PLN' ? Number(variant.regular_price_snapshot) || 0 : 0;
      const regularPrice = comparePrice > price ? comparePrice : snapshotPrice;
      const lowestPrice = moneyInCents(variant.lowest_price_30_days);
      const validUntil = new Date(variant.lowest_price_30_days_valid_to || '');
      const validOmnibus = !Number.isNaN(validUntil.getTime()) && validUntil.getTime() >= Date.now();
      const onSale = validOmnibus && lowestPrice > 0 && regularPrice > price;
      const savings = onSale ? regularPrice - price : 0;

      priceRoot.classList.toggle('price--on-sale', onSale);
      priceRoot.dataset.currentPrice = String(price);
      priceRoot.dataset.comparePrice = onSale ? String(regularPrice) : String(comparePrice);
      priceRoot.dataset.lowestPrice30Days = onSale ? String(lowestPrice) : '';

      const regularCurrentValue = priceRoot.querySelector('.price__regular [data-regular-price]');
      const saleCurrentValue = priceRoot.querySelector('.price__sale [data-sale-price]');
      const saleRegularValue = priceRoot.querySelector('.price__sale [data-regular-price]');
      if (regularCurrentValue) regularCurrentValue.textContent = formatMoney(price);
      if (saleCurrentValue) saleCurrentValue.textContent = onSale ? formatMoney(price) : '';
      if (saleRegularValue) saleRegularValue.textContent = onSale ? formatMoney(regularPrice) : '';

      const saleBadge = priceRoot.querySelector('.price__badge--sale');
      if (saleBadge) {
        saleBadge.replaceChildren();
        const label = document.createElement('span');
        const value = document.createElement('strong');
        label.textContent = savingsLabel;
        value.dataset.ynPriceSavings = '';
        value.textContent = formatMoney(savings);
        saleBadge.append(label, document.createTextNode(' '), value);
      }

      const omnibusLine = priceRoot.querySelector('[data-yn-price-omnibus]');
      const omnibusValue = priceRoot.querySelector('[data-yn-price-omnibus-value]');
      if (omnibusLine) omnibusLine.hidden = !onSale;
      if (omnibusValue) omnibusValue.textContent = onSale ? formatMoney(lowestPrice) : '';
    };

    section.dataset.ynOmnibusReady = 'true';
    variantInput.addEventListener('change', () => requestAnimationFrame(sync));
    sync();
  };

  const initializeSection = (section) => {
    if (!(section instanceof Element)) return;
    placeTopElements(section);
    initializeAssurance(section);
    initializeOmnibusPricing(section);
    requestAnimationFrame(() => placeTopElements(section));
    window.setTimeout(() => placeTopElements(section), 450);
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-section-type="product__section"]').forEach(initializeSection);
    if (scope.matches?.('[data-section-type="product__section"]')) initializeSection(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
